import * as React from 'react';
export const IcTooth = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.93 7.12c-.34-2.03-1.98-3.68-4.01-4.04-1.08-.19-2.1-.04-2.98.37-1.22.56-2.65.56-3.87 0-.88-.41-1.9-.56-2.98-.37-2.03.36-3.66 2.01-4.01 4.04-.32 1.91.44 3.66 1.77 4.74.72.58 1.16 1.44 1.16 2.36v2.77c0 2.04 1.39 4.07 3.08 4 .52-.02.92-.48.92-1v-4c0-1.1.9-2 2-2s2 .9 2 2v4c0 .52.4.98.92 1 1.69.07 3.08-1.96 3.08-4v-2.77c0-.92.44-1.78 1.16-2.36a4.988 4.988 0 001.77-4.74h-.01z'
      fill='currentColor'
    />
  </svg>
);
